<template>
  <!-- Toggle Sidebar Button -->
  <div>
    <div class="mobile-toggle-button-wrapper">
      <div class="mobile-toggle-button" @click="toggleSidebar">
        <i class="fas fa-chevron-right icon-style fa-lg" style="margin-bottom: 30px;"></i>
      </div>
    </div>

    <!-- Profile Sidebar -->
    <div class="profile-sidebar" :class="{ open: isSidebarOpen }"
      style="border: 1px solid #CCCCCC; background-color: #f8f8f8; margin: 0;">
      <div class="widget-profile pro-widget-content" style="border: none; background-color: #f8f8f8; margin: 0;">
        <div class="profile-info-widget">
          <router-link to="/doctor/profile-settings" class="booking-doc-img">
            <img v-bind:src="user_image
              ? config.base_url_for_Image + user_image
              : doctor_profile.gender === 'Female'
                ? loadImg('female_doctor.jpg')
                : loadImg('Doctor Profile.svg')
              " alt="User Image" />
          </router-link>

          <div class="profile-det-info">
            <h3>{{first_name }} {{ last_name }}</h3>

            <div class="patient-details">
              <h5 class="mb-0">{{ get_doctor_qualification() }}</h5>
            </div>
          </div>
        </div>
        <div class="d-flex form-group">
          <div class="col-9 col-md-9 change-avatar">
            <div class="profile-img"></div>
            <div class="upload-img">
              <div class="change-photo-btn ml-5" style="width:80%;">
                <span>
                  <i class="fa fa-upload"></i>
                  {{ user_image ? "Change" : "Upload" }}
                </span>
                <input type="file" class="upload" accept="image/*" @change="onFileChange($event, 'main_image')" />
              </div>
              <small class="form-text text-muted" style="margin-left: 20%; width: 175px; text-align: center;">Allowed JPG,
                GIF or PNG</small>
              <small class="form-text text-muted" style="margin-left: 20%; width: 175px; text-align: center;">Max size of
                2MB</small>
            </div>
          </div>
          <div class="
                              col-3 col-md-3
                              submit-section submit-btn-bottom
                              text-right
                            "></div>
        </div>
      </div>
      <div class="dashboard-widget">
        <nav class="dashboard-menu">
          <ul>
            <!-- <li :class="currentPath == 'doctor-index' ? 'active' : 'notactive'">
              <router-link to="/doctor/index">
                <i class="fas fa-tasks"></i>
                <span>Onboarding</span>
              </router-link>
            </li> -->
            <li :class="currentPath == 'doctor-index' ? 'active' : 'notactive'">
              <router-link to="/doctor/index">
                <i class="fas fa-tachometer-alt"></i>
                <span>Dashboard</span>
              </router-link>
            </li>

            <li :class="currentPath == 'profile-settings' ? 'active' : 'notactive'">
              <router-link to="/doctor/profile-settings">
                <i class="fas fa-user-cog"></i>
                <span>Profile</span>
              </router-link>
            </li>
            
            <li :class="currentPath == 'doctor-appointments' ? 'active' : 'notactive'
              ">
              <router-link to="/doctor/appointments">
                <i class="fas fa-calendar-check"></i>
                <span>My Appointments</span>
              </router-link>
            </li>

            <li :class="currentPath == 'new-patient-encounter' ||
              currentPath == 'patient-encounter' ||
              currentPath == 'update-patient-encounter-update'
              ? 'active'
              : 'notactive'
              ">
              <router-link to="/doctor/patient-encounter">
                <!-- <i class="fas fa-x-ray" ></i>  -->
                <i class="fa fa-heartbeat"></i>
                <span>Patient Encounter</span>
              </router-link>
            </li>

            <li :class="currentPath == 'my-patients' ? 'active' : 'notactive'">
              <router-link to="/doctor/patients">
                <i class="fas fa-user-injured"></i>
                <span>My Patients</span>
              </router-link>
            </li>

            <li :class="currentPath == 'reciept' ? 'active' : 'notactive'">
              <router-link to="/doctor/reciept">
                <i class="fas fa-receipt"></i>
                <span>Payouts</span>
              </router-link>
            </li>

            <li :class="currentPath == 'my-treatment-plan' ||
              currentPath == 'treatment-plan'
              ? 'active'
              : 'notactive'
              ">
              <router-link to="/doctor/treatment-plan">
                <i class="fas fa-stethoscope"></i>
                <span>Treatment Plans</span>
              </router-link>
            </li>

            <li :class="currentPath == 'schedule-timings' ||
              currentPath == 'new-schedule-timings' ||
              currentPath == 'edit-schedule-timings'
              ? 'active'
              : 'notactive'
              ">
              <router-link to="/doctor/schedule-timings">
                <i class="fas fa-hourglass-start"></i>
                <span>Schedule</span>
              </router-link>
            </li>
            <li :class="currentPath == 'my-services' ? 'active' : 'notactive'">
            <router-link to="/doctor/my-services">
              <i class="fa fa-wrench"></i>
              <span>My Services</span>
            </router-link>
          </li>

            <li :class="currentPath == 'video-library' ? 'active' : 'notactive'
              ">
              <router-link to="/doctor/video-library">
                <i class="fas fa-play-circle"></i>
                <span>Video Library</span>
              </router-link>
            </li>
            <li :class="currentPath == 'training' ? 'active' : 'notactive'
              ">
              <router-link to="/doctor/training">
                <i class="fas fa-chalkboard-teacher"></i>
                <span>Training</span>
              </router-link>
            </li>
            <li :class="currentPath == 'social-media' ? 'active' : 'notactive'">
              <router-link to="/doctor/social-media">
                <i class="fas fa-share-alt"></i>
                <span>Social Media</span>
              </router-link>
            </li>
            <li :class="currentPath == 'doctor-reviews' ? 'active' : 'notactive'">
              <router-link to="/doctor/reviews">
                <i class="fas fa-star"></i>
                <span>Reviews</span>
              </router-link>
            </li>

            <!-- collapse Sidebar -->
            
            <li :class="currentPath == 'account-details' ? 'active' : 'notactive'">
            <router-link to="/doctor/account-details">
              <i class="fa fa-bank"></i>
              <span>Bank Details</span>
            </router-link>
          </li>
            <li :class="currentPath == 'referal' ? 'active' : 'notactive'">
              <router-link to="/doctor/referal">
                <i class="fas fa-user-friends"></i>
                <span>Invite Friends</span>
              </router-link>
            </li>
            <!-- <hr> -->

            <li>
              <a href="javascript:void(0);" @click="submit_logout" class="dropdown-item"><i
                  class="fas fa-sign-out-alt"></i><span>Logout</span></a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <!-- /Profile Sidebar -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import config from "../../../services/CommonApi";
import CommonApi from "../../../services/CommonApi";
const images = require.context("@/assets/img/doctors");
export default {
  data() {
    return {
      isSidebarOpen: false,
      first_name:"",
      last_name:"",
      doctor_profile: {
        gender: "",
      },

      username: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).username
        : null,
      user_image: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).image
        : null,
      qualification: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).qualification
        : null,
      config: config,
    };
    
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
  },

  mounted(){
    this.get_doctor_details();
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen; // Toggle the variable
    },

    get_doctor_details() {
      const params = new URLSearchParams();
      params.append("name",this.$store.state.user.user_id);
      CommonApi.get_data("sahaj.api.get_doctor_details", params).then((res) => {
        this.showspinner = false;
        if (res && res.data && res.status_code === 200) {
          this.doctor_profile.gender = res.data.gender;
          console.log(res)
          this.first_name = res.data.first_name;
          this.last_name = res.data.last_name;
        }
      });
    },

    ...mapActions(["signOut"]),

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    navigate(url) {
      this.$router.push(url);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    /* Change Profile Image */
    // onFileChange(e, photo) {
    //   var files = e.target.files;
    //   if (!files.length) return;
    //   this.createImage(files[0], photo);
    // },

    onFileChange(e, photo) {
  var files = e.target.files;

  if (!files.length) return;

  const file = files[0];
  const maxSizeInBytes = 2 * 1024 * 1024; // 2MB

  // Check if the file size exceeds the limit
  if (file.size > maxSizeInBytes) {
    this.$swal.fire({
      icon: "warning",
      title: "File Size Warning",
      text: "The file size exceeds the 2MB limit. Please upload a smaller file",
    });
    return;
  }

  this.createImage(file, photo);
},
    /* Create Profile Image */
    createImage(file, photo) {
      var reader = new FileReader();
      reader.onload = (e) => {
        if (photo === "main_image") {
          this.update_doctor_profile(file.name, e.target.result);
        }
      };
      reader.readAsDataURL(file);
    },

    /* Upload Image API */
    async update_doctor_profile(filename, upload_image) {
      this.$swal({
        text: "Updating Profile Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        doctor: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.profile_photo_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          const retrievedString = localStorage.getItem("userInfo");
          const parsedObject = JSON.parse(retrievedString);
          parsedObject.image = res.data;
          const strigifiedForStorage = JSON.stringify(parsedObject);
          localStorage.setItem("userInfo", strigifiedForStorage);
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },

    get_doctor_qualification() {
      var qualification_string = [];
      this.qualification.map((data) => {
        qualification_string.push(data.qualification);
      });
      return qualification_string.join(" , ");
    },

    async submit_logout() {
      localStorage.removeItem("healthcareStatus");
      localStorage.removeItem("user_id");
      this.signOut();
      this.$store.dispatch("user/setUserType");
      this.$store.dispatch("user/setUserID");
    },
  },
};
</script>

<style>
/* CSS for desktop view (default) */
.profile-sidebar {
  display: block !important;
  /* Always open in desktop view */
}

/* Style for hidden sidebar in desktop view */
.icon-style {
  position: absolute;
  left: -9999px;
}


/* CSS for mobile view (screen width less than 768px, adjust as needed) */
@media (max-width: 768px) {
  .mobile-toggle-button-wrapper {
    display: block;
    /* Show the button in mobile view */
  }
  .icon-style {
    position: static;
    left: auto;
  }

  .widget-profile {
    display: block !important;
  }

  /* Style for hidden sidebar in mobile view */
  .profile-sidebar {
    display: none !important;
  }

  /* Style for open sidebar in mobile view */
  .profile-sidebar.open {
    display: block !important;
  }

}

/* CSS for desktop view (screen width greater than 768px) */
@media (min-width: 768px) {
  .widget-profile {
    display: block !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/layouts/doctors/SideBar.vue